// Real Contract.type choices (backend/clients/models/contract.py) — the old
// ContractTable.js badge map keyed on Purchase/Sale/Lease/Mortgage, none of
// which ever matched a real value, so every row fell through to the
// "secondary" default color.
export const CONTRACT_TYPE_OPTIONS = [
  { value: "", label: "All types" },
  { value: "CASH", label: "Cash" },
  { value: "CREDIT", label: "Credit" },
  { value: "DEVELOPER", label: "Developer" },
  { value: "PRE-CONTRACT", label: "Pre-Contract" },
  { value: "OTHER", label: "Other" },
];

const TYPE_META = {
  CASH: { label: "Cash", color: "success" },
  CREDIT: { label: "Credit", color: "primary" },
  DEVELOPER: { label: "Developer", color: "info" },
  "PRE-CONTRACT": { label: "Pre-Contract", color: "warning" },
  OTHER: { label: "Other", color: "dark" },
};

export const getContractTypeMeta = (type) => TYPE_META[type] || { label: type || "—", color: "secondary" };
